import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { TextField } from '../../components/ui/Field';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
export function AdminLogin() {
  const {
    loggedIn,
    login
  } = useAdminData();
  const navigate = useNavigate();
  const [email, setEmail] = useState(company.email);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  if (loggedIn) return <Navigate to="/admin" replace data-id="element-184" data-mp="edqtz3nz53bu" />;
  return <div className="flex min-h-screen w-full items-center bg-canvas px-5 py-12" data-id="element-185" data-mp="ecxi5oa5rnmu">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto w-full max-w-sm" data-id="element-186" data-mp="1ur75qg6kt8cm">
        <img src={company.logoWide} alt="LYKKEVÆRK" className="h-14 w-auto" data-id="element-187" data-mp="1wnlxewcxw2ij" />
        <h1 className="mt-4 font-display text-xl font-semibold tracking-tight text-ink-soft" data-id="element-188" data-mp="20ofhtfr6az6o">Admin</h1>

        <form className="mt-8 rounded-card border border-line bg-white p-6 md:p-8" onSubmit={event => {
        event.preventDefault();
        if (password !== company.adminPassword) {
          setError('Forkert adgangskode. Prøv igen.');
          return;
        }
        setError('');
        setLoading(true);
        window.setTimeout(() => {
          login();
          navigate('/admin');
        }, 400);
      }} data-id="element-189" data-mp="25pv5lfkqjjsr">
          <TextField id="admin-mail" label="E-mail" type="email" required autoComplete="username" value={email} onChange={event => setEmail(event.target.value)} data-id="element-190" data-mp="1rpkdk97ovz60" />
          <TextField id="admin-kode" label="Password" type="password" required autoComplete="current-password" placeholder="Indtast adgangskode" className="mt-5" value={password} onChange={event => {
          setPassword(event.target.value);
          if (error) setError('');
        }} data-id="element-191" data-mp="r7jyx7gjng7u" />

          {error && <p role="alert" className="mt-4 flex items-start gap-2 rounded-xl bg-accent-soft px-4 py-3 text-sm text-accent-deep" data-id="element-192" data-mp="89g0b6ya8zka">
              <AlertCircleIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-193" data-mp="i7dm7nso6k9q" />
              {error}
            </p>}

          <Button type="submit" size="lg" className="mt-7 w-full" disabled={loading} data-id="element-194" data-mp="d6plgaen2p2b">
            {loading ? 'Logger ind …' : 'Log ind'}
          </Button>
        </form>

        <p className="mt-6 text-center text-sm text-ink-muted" data-id="element-195" data-mp="1om4jlhil3mz0">
          <Link to="/" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-196" data-mp="36l2hzqi7bqr3">
            Tilbage til hjemmesiden
          </Link>
        </p>
      </motion.div>
    </div>;
}